"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Solver {
    constructor(env, opt) {
        this.env = env;
        this.opt = opt;
    }
    getOpt() {
        return this.opt;
    }
    getEnv() {
        return this.env;
    }
}
exports.Solver = Solver;
//# sourceMappingURL=solver.js.map